import aboutData from './about';
import { CareerItem } from '../types';

// Typdefinition für die CV-Daten
export interface Language {
  name: string;
  level: string;
}

export interface CvData {
  title: string;
  exportButtonText: string;
  // Importierte Daten aus anderen Modulen
  careerTimeline: CareerItem[];
  // CV-spezifische Daten
  languages: Language[];
  interests: string[];
  header: {
    name: string;
    title: string;
    email: string;
    location: string;
    website: string;
    phone: string;
  };
}

// CV-spezifische Daten
const cvData: CvData = {
  title: "Lebenslauf",
  exportButtonText: "Als PDF exportieren",
  // Daten aus about.ts importieren
  careerTimeline: aboutData.careerTimeline,
  // CV-spezifische Daten
  languages: [
    { name: "Deutsch", level: "Muttersprache" },
    { name: "Englisch", level: "Fließend (C1)" },
    { name: "Französisch", level: "Grundkenntnisse (A2)" }
  ],
  interests: [
    "Technologien",
    "Games",
    "Kochen",
    "Familie"
  ],
  header: {
    name: "Robin Wichmann",
    title: "Fullstack-Frontend-Entwickler",
    email: "robwichmann@gmail.com",
    location: "Hauptstr. 58c, 21640 Bliedersdorf",
    website: "robinwichmann.com",
    phone: "0173 - 7126379"
  }
};

export default cvData; 